export default {
    filters: {
        trim: (str, options = {}) => {
            if (!str) return ""

            // If options is a string then assume it's the length. e.g. this.trim('string', 5)
            options = _.isObject(options) ? options : { length: parseInt(options) }

            return _.truncate(str.toString(), options)
        },
        dateFormat: (date, format = "MM/DD/YYYY h:mm A", local = true) => {
            if (local) {
                return moment.utc(date).local().format(format)
            }
            return moment.utc(date).format(format)
        },
        datetime: (value) => moment.utc(value).local().format("MM/DD/YYYY h:mm A"),
        date: (value) => moment.utc(value).local().format("MM/DD/YYYY"),
        time: (value) => moment.utc(value).local().format("h:mm A"),
        ago: (value) => moment.utc(value).local().locale("en").fromNow(),
        calendar: (value) => moment.utc(value).local().calendar(),
        when: (value, suffix = null) => {
            if (moment(value).isBefore(moment().subtract(1, "day"))) {
                return moment.utc(value).local().calendar({
                    lastDay: "[1d]",
                    sameDay: "LT",
                    lastWeek: "MMM D",
                    sameElse: "MM/DD/YYYY",
                })
            } else {
                let ago = moment.utc(value).local().fromNow()
                return suffix ? ago + " " + suffix : ago
            }
        },
        daysDifference: (value) => {
            let now = moment()
            let targetDate = moment.utc(value).local()
            let diff = targetDate.diff(now, "days")

            if (diff > 0) {
                return `in ${diff} days`
            } else if (diff < 0) {
                return `${Math.abs(diff)} days ago`
            } else {
                return "Today"
            }
        },
        timestamp: (value) => {
            return moment.utc(value).local().unix()
        },
        toLocaleString: (number) => {
            if (typeof number !== "undefined") {
                return number.toLocaleString()
            }
        },
        abbr: (n) => {
            if (n < 1e3) return n
            if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K"
            if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M"
            if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B"
            if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T"
        },
        padStart: (str, len, chars = " ") => _.padStart(str, len, chars),
    },

    computed: {
        isMobile() {
            return window.matchMedia("(max-width: 767px)").matches
        },
    },

    methods: {
        verifyAuth() {
            return axios.get("/auth").then((response) => response.data)
        },

        formatDate(date, format, local = true) {
            if (local) {
                return moment.utc(date).local().format(format)
            }
            return moment.utc(date).format(format)
        },

        nl2br(str, isXhtml) {
            if (typeof str === "undefined" || str === null) {
                return ""
            }
            const breakTag = isXhtml || typeof isXhtml === "undefined" ? "<br " + "/>" : "<br>"
            return (str + "").replace(/(\r\n|\n\r|\r|\n)/g, breakTag + "$1")
        },

        br2nl(str) {
            if (typeof str === "undefined" || str === null) {
                return ""
            }
            return (str + "").replace(/<br\s*[\/]?>/gi, "\n")
        },

        contains(str, value) {
            return _.includes(str, value)
        },

        isArray(array) {
            return Array.isArray(array)
        },

        isObject(obj) {
            return _.isObject(obj)
        },

        truncate(str, length = 30) {
            return _.truncate(str, { length: length })
        },

        copyToClipboard(event) {
            let textToCopy = ""
            if (typeof event === "string") {
                textToCopy = event
            } else {
                textToCopy = event.target.getAttribute("href")
            }
            // console.log(textToCopy);
            navigator.clipboard.writeText(textToCopy).then(
                () => {
                    /* clipboard successfully set */
                    this.textCopied = true
                },
                () => {
                    /* clipboard write failed */
                }
            )
            return null
        },
    },
}
